import { Typography, Box, styled } from '@mui/material';
import React from 'react';
import {
    MantyStatus,
    RecurrenceEnum,
} from 'routes/HumanResourcesModule/Settings/HrPositionMapping/helpers/constants';
import { HypothesisChoice } from './constants';
import HypothesisSelector from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Agents/components/AddHypotheses/AgentHypothesisModal/HypothesisSelector';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import PaymentsIcon from '@mui/icons-material/Payments';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import VerifiedIcon from '@mui/icons-material/Verified';
import { AgentDepartureHypothesis } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Agents/components/Departure/helpers/types';
import { AgentPayComponentHypothesis } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Agents/components/PayComponent/helpers/types';
import { GradeAdvancementHypothesis } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Agents/components/GradeAdvancement/helpers/types';
import Flex from 'ui/Flex/Flex';
import { useTranslation } from 'react-i18next';

const StyFlex = styled(Flex, {
    name: 'StyFlex',
})<{ children: JSX.Element[] }>(({ children }) => ({
    padding: '2px',
    '& > .MuiButton-root': {
        flexBasis: children.length >= 4 ? '48%' : '31%',
        flexGrow: 1,
    },
}));

type Props = {
    selectedHypothesisType: string | null;
    setSelectedHypothesisType: (value: string | null) => void;
    recurrence: RecurrenceEnum;
    departureHypothesis: AgentDepartureHypothesis | undefined;
    ifseHypothesis: AgentPayComponentHypothesis | undefined;
    ponctualPrimeHypothesis: AgentPayComponentHypothesis | undefined;
    gradeAdvancementHypothesis: GradeAdvancementHypothesis | undefined;
    mantyStatus: MantyStatus;
};
export const HypothesisTypeSelect = ({
    selectedHypothesisType,
    setSelectedHypothesisType,
    departureHypothesis,
    ifseHypothesis,
    ponctualPrimeHypothesis,
    gradeAdvancementHypothesis,
    recurrence,
    mantyStatus,
}: Props): React.ReactElement => {
    const { t } = useTranslation();
    const handleSelectHypothesisType = (type: string) => {
        setSelectedHypothesisType(type);
    };

    const hypothesesSelectors = [
        <HypothesisSelector
            recurrence={recurrence}
            selected={selectedHypothesisType === HypothesisChoice.DEPARTURE}
            hypothesis={departureHypothesis}
            onClick={() =>
                handleSelectHypothesisType(HypothesisChoice.DEPARTURE)
            }
            Icon={ExitToAppIcon}
            title={t(
                'humanResources.simulation.agentHypothesis.departureHypothesis',
            )}
            key="departure"
        />,
    ];
    if (recurrence === RecurrenceEnum.RECURRENT) {
        hypothesesSelectors.push(
            <HypothesisSelector
                recurrence={recurrence}
                selected={selectedHypothesisType === HypothesisChoice.IFSE}
                onClick={() =>
                    handleSelectHypothesisType(HypothesisChoice.IFSE)
                }
                hypothesis={ifseHypothesis}
                Icon={PaymentsIcon}
                title={t(
                    'humanResources.simulation.agentHypothesis.ifseHypotheses',
                )}
                key="ifse"
            />,
        );
    }
    hypothesesSelectors.push(
        <HypothesisSelector
            recurrence={recurrence}
            selected={selectedHypothesisType === HypothesisChoice.PRIME}
            hypothesis={ponctualPrimeHypothesis}
            onClick={() => handleSelectHypothesisType(HypothesisChoice.PRIME)}
            Icon={CardGiftcardIcon}
            title={t(
                'humanResources.simulation.agentHypothesis.ponctualPrimesHypotheses',
            )}
            key="ponctual"
        />,
    );
    if (
        mantyStatus === MantyStatus.TITULAIRE &&
        recurrence === RecurrenceEnum.RECURRENT
    ) {
        hypothesesSelectors.push(
            <HypothesisSelector
                recurrence={recurrence}
                selected={selectedHypothesisType === HypothesisChoice.GRADE}
                onClick={() =>
                    handleSelectHypothesisType(HypothesisChoice.GRADE)
                }
                hypothesis={gradeAdvancementHypothesis}
                Icon={VerifiedIcon}
                title={t(
                    'humanResources.simulation.agentHypothesis.gradeHypotheses',
                )}
                key="grade-advancement"
            />,
        );
    }

    return (
        <Box>
            <Typography>
                {t(
                    'humanResources.simulation.agentHypothesis.chooseHypothesisType',
                )}
            </Typography>
            <StyFlex justifyContent="center" wrap="wrap">
                {hypothesesSelectors}
            </StyFlex>
        </Box>
    );
};
